import { Dialog, DialogContent } from '@mui/material';
import MilestoneForm from './MilestoneForm';

const MilestoneFormDialog = ({
  open,
  onClose,
  sowId,
  sow,
  editingMilestone,
  existingMilestones,
  onSuccess,
  onSowUpdate,
  onDocumentsReset,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth='md'
    aria-label={editingMilestone ? 'Edit milestone' : 'Create milestone'}
  PaperProps={{
    sx: { p: 3, borderRadius: 2 },
  }}
  >
    <DialogContent sx={{ px: 0 }}>
      <MilestoneForm
        sowId={sowId}
        sow={sow}
        milestone={editingMilestone}
        existingMilestones={existingMilestones}
        onSuccess={onSuccess}
        onCancel={onClose}
        onSowUpdate={onSowUpdate}
        onDocumentsReset={onDocumentsReset}
      />
    </DialogContent>
  </Dialog>
);

export default MilestoneFormDialog;
